import EditQuizForm from "../../../components/Admin/Quiz/EditQuizForm";
import Navbar from "../../../components/Navbar";

export default function EditQuiz() {
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-full px-5 lg:px-20">
          <EditQuizForm />
        </div>
      </section>
    </>
  );
}
